import React from "react";
import "./header.scss";

const Header = () => {
  return (
    <header>
      <div id="banner_div">
        <a href="https://netadminpro.pl">
          <img src="logo.png" alt="NetAdminPro Logo" />
        </a>
      </div>
    </header>
  );
};

export default Header;
